<template>
  <div class="page-root" id="import-root">
    <div class="jumbotron h-100 pt-5" id="import-jumbotron">
      <div class="container" id="import-container">
        <div class="row border-between" id="import-rowBorder-between">

          <div class="col-lg-8" id="import-col">
            <h2 class="page-title" id="import-title">{{ 'CASE_IMPORT' | translate }}</h2>

            <form v-on:submit.prevent="submitForm()" id="import-form">
              <div class="form-group mt-3" id="import-formOption-One">
                <div class="form-row" id="import-formOption-One-row">
                  <div class="col-lg-12" id="import-formOption-One-col-lg-12">
                    <span>{{ 'IMPORT_CONSISTS_LINE' | translate }}</span>
                    <input type="radio" id="by-customer" name="import_type" value="customer" v-model="importType" />
                    <label for="by-customer" id="import-formOption-One-byCustomer">&nbsp;{{ 'CUSTOMER' | translate }}</label>
                    <input type="radio" id="by-policy" name="import_type" value="policy" v-model="importType" />
                    <label for="by-policy" id="import-formOption-One-byPolicy">&nbsp;{{ 'POLICY' | translate }}</label>
                    <input type="radio" id="by-cover" name="import_type" value="cover" v-model="importType" />
                    <label for="by-cover" id="import-formOption-One-byCover">&nbsp;{{ 'COVER' | translate }}</label>
                    <input type="radio" id="by-nvga2" name="import_type" value="nvga2.0" v-model="importType" />
                    <label for="by-nvga2" id="import-formOption-One-byNvga2">&nbsp;NVGA2.0</label>
                    <input type="radio" id="by-level" name="import_type" value="level" v-model="importType" />
                    <label for="by-level" id="import-formOption-One-byLevel">&nbsp;Level</label>
                  </div>
                </div>
              </div>
              <div class="form-row mb-4" id="import-productline"
                v-if="importType !== 'nvga2.0' && importType !== 'level'">
                <label for="product_line" class="col-auto col-form-label col-form-label-sm"
                  id="import-productline-label">{{ 'PRODUCT_LINE' | translate }}</label>
                <div class="col" id="import-productline-dropdown">
                  <select class="form-control form-control-sm" v-if="importType !== 'customer'" v-model="productLine"
                    name="product_line" id="product_line" required>
                    <option v-for="(productLine, index) in enabledProductLines" :key="index" :value="productLine"
                      :id="'searchTableRow-' + index">
                      {{ productLine.description }}
                    </option>
                  </select>
                </div>
                <div class="col text-right">
                  <button type="button" class="btn btn-sm btn-link" v-if="productLine || importType == 'customer'"
                    v-on:click="getTemplateDownloadLink(importType, productLine)">{{ 'DOWNLOAD_TEMPLATE' | translate
                    }}</button>
                </div>
              </div>
              <div class="form-row" id="import-uploadRow" v-if="importType === 'level'">
                <div class="col" id="import-uploadCol">
                  <input type="text" class="form-control" id="import_file" name="import_file"
                    placeholder="Enter Policy ID here" v-model="policyId">
                </div>
                <div class="col-lg-3" id="import-buttonSubmit">
                  <button type="submit" id="submit_file" class="btn btn-primary btn-block" v-if="!submitting"
                    :disabled="policyId === ''">{{ 'SUBMIT' | translate }}</button>
                  <img src="/static/loader-tail.svg" width="30" alt="Loading..." v-else>
                </div>
              </div>
              <div class="form-group mt-3" id="import-upload" v-else>
                <div class="form-row" id="import-uploadRow">
                  <div class="col" id="import-uploadCol">
                    <div class="custom-file" id="import-customFile">
                      <input type="file" class="custom-file-input" id="import_file" name="import_file"
                        v-on:change="selectFile" required>
                      <label class="custom-file-label" for="import_file" id="import-uploadLabel">
                        {{ (file && file.name) ? file.name : 'UPLOAD_CASE_LIST' | translate }}
                      </label>
                    </div>
                  </div>
                  <div class="col-lg-3" id="import-buttonSubmit">
                    <button type="submit" id="submit_file" class="btn btn-primary btn-block" v-if="!submitting"
                      :disabled="file === null || (importType === 'policy' && productLine === '')">{{ 'SUBMIT' |
              translate }}</button>
                    <img src="/static/loader-tail.svg" width="30" alt="Loading..." v-else>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <alert-dialog :show="showAlertForNetworkError" :textLabel="'msg.NETWORK_ERROR_BIG_FILE_IMPORT'"
          @hide-dialog="closeNetworkAlert()">
        </alert-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import RestService from '../../service/RestService.js';
import GeneralConfigService from '../../service/GeneralConfigService';
import AlertDialog from '../dialog/AlertDialog';

export default {
  components: { AlertDialog },
  data: function () {
    return {
      rest: this.initRestService(),
      productLine: '',
      importType: 'policy',
      file: null,
      policyId: '',
      submitting: false,
      enabledProductLines: {},
      showAlertForNetworkError: false
    }
  },
  async beforeMount() {
    await this.init();
  },
  methods: {
    initRestService() {
      return new RestService();
    },
    async init() {
      this.enabledProductLines = await GeneralConfigService.getEnabledProductLines();
    },
    getTemplateDownloadLink: function (importType, productLine) {
      if (importType !== 'policy') {
        alert('Not yet implemented');
        return;
      }
      this.rest.getImportTemplateDownloadLink(productLine.name).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${productLine.name}.xlsx`);
        link.click();
        window.URL.revokeObjectURL(url);
      });
    },
    submitForm() {
      let vm = this;
      if (this.importType === 'level') {
        vm.submitting = true;
        // this.handleApiImport(vm); this roundcube method is commented for now can be used or deleted in future
        this.handleLevelImport(vm);
      } else {
        this.submitting = true;
        let formData = this.createFormData();
        if (this.importType === 'customer') {
          this.handleCustomerImport(formData, vm);
        } else if (this.importType === 'level') {
          this.handleApiImport(formData, vm);
        } else {
          this.handlePolicyImport(formData, vm);
        }
      }
    },
    createFormData() {
      let formData = new FormData();
      formData.append('product_line', this.productLine.name);
      formData.append('import_file', this.file);
      formData.append('import_file_name', this.file.name);
      formData.append('import_type', this.importType);
      return formData;
    },
    handleCustomerImport(formData, vm) {
      this.rest.postToCaseServer('/customer', formData)
        .then((response) => {
          this.onCustomerImportSuccess(response, vm);
        }).catch((err) => {
          this.onImportError(err, vm);
        });
    },
    handlePolicyImport(formData, vm) {
      this.rest.postToServer(this.rest.URL_CREATE_IMPORT_JOB, formData)
        .then((response) => {
          this.onPolicyImportSuccess(response, vm);
        }).catch((err) => {
          this.onImportError(err, vm);
        });
    },
    handleNvgaImport(formData, vm) {
      this.rest.postToServer(this.rest.URL_CREATE_IMPORT_JOB, formData)
        .then((response) => {
          this.onPolicyImportSuccess(response, vm);
        }).catch((err) => {
          this.onImportError(err, vm);
        });
    },
    handleApiImport(vm) {
      this.rest.getFromCaseServer(this.policyId)
        .then((response) => {
          this.$router.push('/case/' + response.data.policyCaseHeaderId);
        }).catch((err) => {
          this.onImportError(err, vm);
        });
    },
    handleLevelImport(vm) {
      this.levelImport(vm);
    },
    async levelImport(vm) {
      try {
        const levelImportResponse = await this.rest.onLevelImport(this.policyId);
        this.levelResponse = levelImportResponse.data;
        this.$router.push('/case/' + this.levelResponse.policyCaseHeaderId);
      } catch (err) {
        this.onImportError(err, vm);
      } finally {
        vm.submitting = false;
      }
    },
    onCustomerImportSuccess(response, vm) {
      GeneralConfigService.forceUpdateCustomerBatchIds = true;
      vm.submitting = false;
      if (response.data.length !== 0) {
        this.setWarningMessage(this.$options.filters.translate('FOLLOWING_WARNINGS_OCCURRED', 'msg') + ' ' + response.data);
      } else {
        this.setSuccessMessage(this.$options.filters.translate('CUSTOMERS_UPLOAD_SUCCESS', 'msg'));
      }
      setTimeout(() => {
        vm.file = null;
        document.getElementById('import_file').title = this.$options.filters.translate('UPLOAD_CUSTOMER_LIST');
        vm.init();
      }, 300);
    },
    onPolicyImportSuccess(response, vm) {
      let id = response.data;
      vm.$router.push('/job/' + id);
    },
    onImportError(err, vm) {
      vm.submitting = false;
      if (err && err.response && err.response.data) {
        this.setErrorMessage(err.response.data);
      } else {
        this.setErrorMessage(err);
      }
      if (typeof err.response !== 'undefined') {
        this.$log.error(err.response.data);
      } else {
        this.$log.error(err);
      }
    },
    selectFile: function (evt) {
      let files = evt.target.files || evt.dataTransfer.files;
      this.file = files[0];
    },
    setSuccessMessage(message) {
      this.$notify({ type: 'alert-success', text: message });
    },
    setWarningMessage(message) {
      this.$notify({ type: 'alert-warning', duration: -1, text: message });
    },
    setErrorMessage: function (message) {
      this.$notify({ type: 'alert-danger', duration: -1, text: message });
    },
    closeNetworkAlert: function () {
      this.showAlertForNetworkError = false;
      window.location.reload();
    }
  }
}
</script>
<style lang="scss" scoped>
.card-header {
  color: $dark;
  background-color: $light;
}

.border-between {
  >div:first-child {
    padding-right: 30px;
    min-height: 80vh;
    border-right: 1px solid $white;
  }

  >div:nth-child(2) {
    padding-left: 30px;
  }
}

.form-row>.col:first-child {
  padding-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/import/Import.vue